// extracted by mini-css-extract-plugin
export default {"title":"Title_title__GqNA0","regtangle":"Title_regtangle__eVT8A","small":"Title_small__OG16O","text":"Title_text__+qroM"};